<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<form-company-admin
			:company-id="companySvc.company.id"
			action="create"
			class="form-sm"
		>
			<template #return>
				<base-button
					@click.stop="syncModal = false"
					:disabled="formProcessing"
					type="white"
					size="md"
					class="form-btn bg-transparent px-0 font-weight-normal shadow-none"
					>Cancel</base-button
				>
			</template>
		</form-company-admin>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import FormCompanyAdmin from "@components/FormCompanyAdmin";

export default {
	name: "company-admin-modal",
	components: {
		FormCompanyAdmin,
	},
	inject: ["companySvc", "ErrorService"],
	data() {
		return {
			syncModal: false,
			formProcessing: false,
		};
	},
	mounted() {
		this.ErrorService.stopProcessingOnFail(this);

		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("company-admin" === payload.key)
				this.syncModal = payload.active;
		});

		this.$bus.trackEvent("company-admin-form-processing", (payload) => {
			this.syncModal = payload;
			this.formProcessing = payload;
		});
	},
};
</script>
